export enum PortalsCode {
    STORE_360 = '360°',
    OC = 'OC',
    SMARTLY = 'SMRT',
}
